import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { SubmitAppraisalStore } from '../stores';

export const useSubmitAppraisalStore = () => useContext<{
  submitAppraisalStore: SubmitAppraisalStore
}>(StoreContext);
